define('modules/lp_leads/views/main',['require','exports','module','base/view','../collections/leads','env','./lead_listing','services/auth','ldsh!../templates/main'],function(require, exports, module){
  "use strict";

  var BaseView = require("base/view"),
      LeadCollection = require("../collections/leads"),
      config = require("env"),
      LeadCollectionView = require("./lead_listing"),
      Auth = require('services/auth'),
      authInfo = Auth.getAuthInfo();

  /**
   * configuration for Lead collection
   * @type {Object}
   */
  var leadsConfig = {
    /** @type {Number} Number of leads per page */
    pageSize: 25
  };

  module.exports = BaseView.extend({
    template: require("ldsh!../templates/main"),
    className: "ed-leads",

    events: {
      "click .js-pager-first": "showFirstPage",
      "click .js-pager-prev": "showPrevPage",
      "click .js-pager": "showPage",
      "click .js-pager-next": "showNext",
      "click .js-pager-last": "showLast",
      "click .js-download": "downloadLeads"
    },

    initialize: function(options){
      this.date = options.date;
      // uncomment if server is able to filter leads by date
      //this.listenTo(this.date, "change", this.fetchLeads);
      this.listenTo(this.date, "setValues", this.downloadFilteredLeads);
      this.collection = new LeadCollection([], {id: this.model.id, pageSize: leadsConfig.pageSize});
      this.listenTo(this.collection, "sync", this.render);
      this.fetchLeads();
    },

    fetchLeads: function(){
      this.collection.fetch({
        reset: true,
        // uncomment if server is able to filter leads by date
        //data: _.clone(this.date.attributes)
      });
    },

    showFirstPage: function(e){
      e.preventDefault();
      this.collection.fetchFirstPage();
    },

    showPrevPage: function(e){
      e.preventDefault();
      this.collection.fetchPreviousPage();
    },

    showPage: function(e){
      e.preventDefault();
      var page = parseInt($(e.currentTarget).data("page"));
      this.collection.fetchPage(page);
    },

    showNext: function(e){
      e.preventDefault();
      this.collection.fetchNextPage();
    },

    showLast: function(e){
      e.preventDefault();
      this.collection.fetchLastPage();
    },

    downloadLeads: function(e){
      authInfo.initFromLocalStorage();
      e.preventDefault();
      window.open(config.apiHost + "/pages/" + this.model.id + "/leads.csv?bearer=" + authInfo.getAccessToken());
    },

    downloadFilteredLeads: function(){
      authInfo.initFromLocalStorage();
      var url = [config.apiHost, "pages", this.model.id, "leads.csv"].join("/"),
          querystring = _.map([
            ["bearer", authInfo.getAccessToken()],
            ["from", encodeURIComponent(this.date.get("from"))],
            ["to", encodeURIComponent(this.date.get("to"))]
          ], function(param){ return param.join("="); }).join("&");
      window.open(url + "?" + querystring);
    },

    helpers: function() {
      return {
        pageCount: this.collection.pageCount,
        currentPage: this.collection.page,
        startPage: Math.max(this.collection.page - 2, 1),
        endPage: Math.min(this.collection.page + 3, this.collection.pageCount)
      };
    },

    onRender: function() {
      this.$el.i18n();
      if(this.collection.loaded){
        var tableView = new LeadCollectionView({ collection: this.collection, page: this.model });
        this.$(".ed-table-container").html(tableView.render().$el);
      }
      if(this.collection.pageCount === 1){
        //hide paginator
        this.$(".ed-pagination").hide();
      }
      else {
        this.$(".ed-pagination").show();
      }
    }
  });
});

